import React, {useEffect} from 'react';
import {RouteConfig} from "../Config/RouteConfig";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import Header from "./Header";
import ProtectedRoute from "../Config/ProtectedRoute";
import CategoryControlPage from "../Pages/CategoryControlPage";
import HelpPage from "../Pages/HelpPage";
import LoginPage from "../Pages/LoginPage";
import {AuthProvider} from "../Infrastructure/provider/AuthProvider";
import CategoryPage from "../Pages/CategoryPage";

const Router = () => {
    return (
        <AuthProvider>
            <Routes>
                {Object.values(RouteConfig).map(({element, path, name}) =>
                    <Route
                        key = {path}
                        path = {path}
                        element={(
                            <div className={'container mx-auto px-4 sm:px-6 md:px-8 lg:px-8 3xl:px-0'}>
                                <Header name={name}/>
                                {element}
                            </div>
                        )}
                    />
                )}
            </Routes>
        </AuthProvider>
    );
};

export default Router;